import { Dialog as RadixDialog } from '@radix-ui/themes'
import type { ComponentPropsWithoutRef } from 'react'
import { forwardRef } from 'react'

type DialogRootProps = ComponentPropsWithoutRef<typeof RadixDialog.Root>
type DialogTriggerProps = ComponentPropsWithoutRef<typeof RadixDialog.Trigger>
type DialogContentProps = ComponentPropsWithoutRef<typeof RadixDialog.Content>
type DialogTitleProps = ComponentPropsWithoutRef<typeof RadixDialog.Title>
type DialogDescriptionProps = ComponentPropsWithoutRef<
  typeof RadixDialog.Description
>
type DialogCloseProps = ComponentPropsWithoutRef<typeof RadixDialog.Close>

const DialogRoot = forwardRef<HTMLDivElement, DialogRootProps>((props) => {
  return <RadixDialog.Root {...props} />
})

DialogRoot.displayName = 'Dialog.Root'

const DialogTrigger = forwardRef<HTMLButtonElement, DialogTriggerProps>(
  (props, ref) => {
    return <RadixDialog.Trigger ref={ref} {...props} />
  }
)

DialogTrigger.displayName = 'Dialog.Trigger'

const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(
  ({ size = '3', maxWidth = '600px', ...props }, ref) => {
    return (
      <RadixDialog.Content
        maxWidth={maxWidth}
        ref={ref}
        size={size}
        {...props}
      />
    )
  }
)

DialogContent.displayName = 'Dialog.Content'

const DialogTitle = forwardRef<HTMLHeadingElement, DialogTitleProps>(
  (props, ref) => {
    return <RadixDialog.Title ref={ref} {...props} />
  }
)

DialogTitle.displayName = 'Dialog.Title'

const DialogDescription = forwardRef<
  HTMLParagraphElement,
  DialogDescriptionProps
>((props, ref) => {
  return <RadixDialog.Description ref={ref} {...props} />
})

DialogDescription.displayName = 'Dialog.Description'

const DialogClose = forwardRef<HTMLButtonElement, DialogCloseProps>(
  (props, ref) => {
    return <RadixDialog.Close ref={ref} {...props} />
  }
)

DialogClose.displayName = 'Dialog.Close'

export const Dialog = {
  Root: DialogRoot,
  Trigger: DialogTrigger,
  Content: DialogContent,
  Title: DialogTitle,
  Description: DialogDescription,
  Close: DialogClose
}
